// Shared react-query cache helper for the AI risk session
// (key ["aiRiskSession", projectId]) — used by the hazard-mutating hooks to
// merge a PATCH/generate response back into the cached session without a
// refetch.

import { QueryClient } from "react-query";

import { AIHazardShell, AIRiskSession } from "../types";

export const AI_RISK_SESSION_QUERY_KEY = "aiRiskSession";

export const mergeHazardIntoSessionCache = (
  queryClient: QueryClient,
  projectId: string,
  hazard: AIHazardShell
) => {
  queryClient.setQueryData<AIRiskSession | null>(
    [AI_RISK_SESSION_QUERY_KEY, projectId],
    (session) => {
      if (!session) {
        // No cached session (e.g. cache evicted) — nothing to merge into;
        // the next GET re-syncs from the persisted server state.
        return session ?? null;
      }

      return {
        ...session,
        hazards: session.hazards.map((candidate) =>
          candidate.id === hazard.id ? hazard : candidate
        ),
      };
    }
  );
};
